import {call, put, takeLatest} from "redux-saga/effects";

import {
  getAddress,
  addNewAddress,
  updateAddress,
  deleteAddress,
} from "../AsyncActions/address.async";

import * as actions from "../action.constants";

function* addressRequest(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getAddress, pageUrl);
    if (response) {
      yield put({type: actions.STORE_ADDRESS, payload: response?.data});
    }
  } catch (e) {
    /* empty */
  }
}

function* addAddressRequest(action = {}) {
  const {callback = () => {}, requestPayload = {}} = action;
  try {
    const response = yield call(addNewAddress, requestPayload);
    if (response) {
      if (callback) {
        callback();
      }
    }
  } catch (e) {
    /* empty */
  }
}

function* updateAddressRequest(action = {}) {
  const {requestPayload = {}, callback = () => {}} = action;
  try {
    const response = yield call(
      updateAddress,
      {
        org_address_id: requestPayload?.id,
      },
      requestPayload
    );
    if (response) {
      if (callback) {
        callback();
      }
    }
  } catch (e) {
    /* empty */
  }
}

function* deleteAddressRequest(action = {}) {
  const {requestPayload = {}, callback = () => {}} = action;
  try {
    const response = yield call(
      deleteAddress,
      {
        org_address_id: requestPayload,
      },
      requestPayload
    );
    if (response) {
      yield callback();
    }
  } catch (e) {
    /* empty */
  }
}

export function* addressSaga() {
  yield takeLatest(actions.REQUEST_ADDRESS_SAGA, addressRequest);
  yield takeLatest(actions.REQUEST_ADD_ADDRESS_SAGA, addAddressRequest);
  yield takeLatest(actions.REQUEST_UPDATE_ADDRESS_SAGA, updateAddressRequest);
  yield takeLatest(actions.REQUEST_DELETE_ADDRESS_SAGA, deleteAddressRequest);
}
